function finishTaskAlertDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/finish-task-alert/finish-task-alert-dialog.html?$$REVISION$$'
  }
}

export { finishTaskAlertDialogDirective }
